import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class DailySlaReportService extends Service{
    constructor() {
        super();
        this.baseURL = 'dailySlaReport';
    }

    findDailySlaReportView = () => {
        return fetch(SERVER_URL + this.baseURL + '/findDailySlaReportView', {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

}